import { SecretsManagerServer } from '~/plugins/secrets-manager/server'

const isDevelopment = () => process.env.NODE_ENV !== 'production'
const isProduction = () => process.env.NODE_ENV === 'production'

const setup = async () => {
  const isEnvironmentProduction = isProduction()

  if (!isEnvironmentProduction) {
    console.info(`Skipped ensure environment variables in development.`)
    return
  }

  const variablesSecretId = process.env.SERVER_ENVIRONMENT_VARIABLES_SECRET_ID

  const variables =
    await SecretsManagerServer.service.getSecret(variablesSecretId)

  const variablesParsed = JSON.parse(variables)

  Object.entries(variablesParsed).forEach(([key, value]) => {
    process.env[key] = value as string
  })
}

const getBaseUrl = () => {
  const isClient = typeof window !== 'undefined'

  if (isClient) {
    return window.location.origin
  }

  const baseUrl = process.env.BASE_URL
  const port = process.env.PORT ?? 8099

  if (baseUrl) {
    if (baseUrl.startsWith('http')) {
      return baseUrl
    } else {
      return `https://${baseUrl}`
    }
  }

  return `http://localhost:${port}`
}

const getAuthenticationSecret = () => {
  return process.env.SERVER_AUTHENTICATION_SECRET
}

const getAppType = () => {
  return process.env.APP_TYPE
}

const isAppWorker = () => {
  const type = getAppType()

  if (isDevelopment() && !type) {
    return true
  }

  return type === 'WORKER'
}

const isAppGateway = () => {
  const type = getAppType()

  if (isDevelopment() && !type) {
    return true
  }

  return type === 'GATEWAY'
}

export const Configuration = {
  isDevelopment,
  isProduction,
  isAppWorker,
  isAppGateway,
  getBaseUrl,
  getAuthenticationSecret,
  setup,
}
